import classNames from 'classnames';
import {useEffect, useRef, useState} from 'react';

interface IAccordionProps {
  headerClassName?: string;
  accordionTitle: string;
  children: React.ReactNode;
  openAccordion: boolean;
  setOpenAccordion: React.Dispatch<React.SetStateAction<boolean>>;
}

const Accordion = ({
  accordionTitle,
  headerClassName,
  children,
  openAccordion,
  setOpenAccordion,
}: IAccordionProps) => {
  const contentHeight = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (openAccordion) {
      const contentEl = contentHeight.current as HTMLDivElement;

      setHeight(contentEl.scrollHeight);
    } else {
      setHeight(0);
    }
  }, [openAccordion]);

  return (
    <div className="w-full">
      <div
        className={classNames(
          'flex justify-between items-center h-16 text-sm',
          headerClassName,
        )}
        onClick={() => setOpenAccordion(!openAccordion)}
      >
        <span> {accordionTitle}</span>
        <i
          className={classNames('icon-styleoutline1 text-lg', {
            'icon-nameArrow---Down-2-1': !openAccordion,
            'icon-nameArrow---Up-2': openAccordion,
          })}
        />
      </div>
      <div
        ref={contentHeight}
        style={{height}}
        className={'h-0 overflow-hidden transition-all'}
      >
        {children}
      </div>
    </div>
  );
};

export default Accordion;
